// Pantalla intermedia post-pago — SOLO argentinos (Rebill). Tras un pago exitoso,
// el "Continuar" del checkout trae acá en vez de ir directo al estudio. Ofrece
// cargar los datos fiscales para facturar por AFIP (este pago y los próximos).
// "Sí" → /facturacion (portal, con contexto postPago). "No" → entra al estudio.
// Es puro front: no emite ni guarda nada; solo rutea. El gateo AR real vive en el
// punto de entrada (el "Continuar" del checkout solo llega acá si isArgentina) y
// en /facturacion (que redirige al home a los no-AR).
// Ver ADR-2026-08-13-facturacion-pantalla-post-pago-ar.

import { useEffect } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { Receipt, ArrowRight } from 'lucide-react';
import { useUserGroup } from '../hooks/useUserGroup';
import { entryStudioPath } from '../lib/userGroups';

export default function FacturacionOferta() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { isDevTester, grupo } = useUserGroup();
  const homePath = entryStudioPath(isDevTester, grupo);

  // Esta pantalla solo tiene sentido viniendo de un pago (postPago en el state).
  // Si alguien entra directo por URL o refresca (se pierde el state), lo mandamos
  // al estudio en vez de mostrarle una oferta suelta. `?preview` la fuerza para
  // poder revisar el diseño / testear sin tener que pagar.
  const preview = searchParams.get('preview') !== null;
  const puedeVerse =
    preview || (location.state as { postPago?: boolean } | null)?.postPago === true;
  useEffect(() => {
    if (!puedeVerse) navigate(homePath, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (!puedeVerse) return null;

  const configurarFacturacion = () =>
    // postPago va por query param (?postPago=1): sobrevive un refresh de /facturacion (el
    // location.state se pierde al recargar), así el portal sigue mostrando "Entrar a Atlas". Greptile PR#67.
    navigate('/facturacion?postPago=1');
  const entrarAlEstudio = () => navigate(homePath, { replace: true });

  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center overflow-y-auto bg-surface-card px-5 py-10">
      <div className="w-full max-w-md text-center">
        <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-neutral-100 text-brand-primary">
          <Receipt className="h-7 w-7" />
        </div>
        <h1 className="text-[22px] font-bold leading-tight tracking-tight text-brand-black/90">
          ¿Querés la factura de tu plan?
        </h1>
        <p className="mx-auto mt-2 max-w-sm text-[14px] leading-snug text-neutral-500">
          Cargá tus datos fiscales una vez y te generamos la factura AFIP de este
          pago y de los próximos. Podés descontar el IVA.
        </p>

        <div className="mt-7 flex flex-col gap-2.5">
          <button
            type="button"
            onClick={configurarFacturacion}
            className="inline-flex h-11 items-center justify-center gap-1.5 rounded-md bg-brand-primary px-5 text-[15px] font-medium text-white transition-colors hover:bg-brand-primary-hover"
          >
            Sí, configurar facturación <ArrowRight className="h-4 w-4" />
          </button>
          <button
            type="button"
            onClick={entrarAlEstudio}
            className="inline-flex h-11 items-center justify-center rounded-md px-5 text-[14px] font-medium text-neutral-500 transition-colors hover:text-brand-black/80"
          >
            Ahora no, entrar al estudio
          </button>
        </div>
      </div>
    </div>
  );
}
